import SXAjax, { createAjaxHoc } from '@/library/ajax';
import qs from 'qs';
import mockUrls from '../mock/url-config';
import handleError from './handle-error';
import handleSuccess from './handle-success';
import configEnv from './configEnv';
import { getLoginUser } from './index';

let currentCompanyDeptId = null;
let currentCompanyDeptUserId = null;
const companyDeptListeners = new Set();

export const getCurrentCompanyDeptId = () => {
    const user = getLoginUser();
    if (currentCompanyDeptUserId !== (user && user.id)) {
        currentCompanyDeptId = null;
        currentCompanyDeptUserId = null;
    }
    return currentCompanyDeptId;
};
export const setCurrentCompanyDeptId = (id) => {
    const previousId = getCurrentCompanyDeptId();
    if (id === previousId) return;
    const user = getLoginUser();
    currentCompanyDeptUserId = user && user.id;
    currentCompanyDeptId = id;
    companyDeptListeners.forEach(listener => listener(id));
};
export const subscribeCompanyDept = (listener) => {
    companyDeptListeners.add(listener);
    return () => companyDeptListeners.delete(listener);
};

// 拼接跳转链接用的 companyDeptId 参数；为空或 all 时不携带，与接口注入的过滤规则保持一致
export const getCompanyDeptIdUrlParam = () => {
    const companyDeptId = getCurrentCompanyDeptId();
    if (companyDeptId === null || companyDeptId === undefined || companyDeptId === '' || companyDeptId === 'all') return '';
    return `&companyDeptId=${companyDeptId}`;
};

// 仅已验证支持 companyDeptId 的列表查询；不触碰机构树、登录及写操作。
const noCompanyDeptListUrls = new Set([
]);

const injectCompanyDept = (cfg) => {
    const hasId = value => {
        if (typeof value === 'string') {
            try {
                value = JSON.parse(value);
            } catch (error) {
                value = qs.parse(value);
            }
        }
        return value && Object.prototype.hasOwnProperty.call(value, 'id') && value.id !== null && value.id !== undefined && value.id !== '';
    };
    if (hasId(cfg.params) || (typeof FormData !== 'undefined' && cfg.data instanceof FormData ? cfg.data.has('id') && cfg.data.get('id') !== null && cfg.data.get('id') !== undefined && cfg.data.get('id') !== '' : hasId(cfg.data))) {
       return cfg;
    }
    const companyDeptId = getCurrentCompanyDeptId();
    if (companyDeptId === null || companyDeptId === undefined || companyDeptId === '' || companyDeptId === 'all') {
        return cfg;
    }
    const path = cfg.url && cfg.url.split('?')[0].replace(/^https?:\/\/[^/]+(?:\/api)?/, '').replace(/^\/api(?=\/agent\/)/, '');
    if (noCompanyDeptListUrls.has(path)) return cfg;

    const method = (cfg.method || 'get').toLowerCase();
    if (method === 'get') {
        if (!Object.prototype.hasOwnProperty.call(cfg.params || {}, 'companyDeptId')) {
            cfg.params = {companyDeptId, ...cfg.params };
        }
    } else if (method === 'post') {
        const headers = cfg.headers || {};
        const methodHeaders = headers[method] || {};
        const contentType = headers['Content-Type'] || headers['content-type'] || methodHeaders['Content-Type'] || methodHeaders['content-type'] || '';
        if (typeof FormData !== 'undefined' && cfg.data instanceof FormData) {
            if (!cfg.data.has('companyDeptId')) cfg.data.set('companyDeptId', companyDeptId);
        } else if (typeof cfg.data === 'string' && contentType.includes('application/x-www-form-urlencoded')) {
            const data = qs.parse(cfg.data);
            cfg.data = qs.stringify({ companyDeptId, ...data });
        } else if (contentType.includes('application/json') && cfg.data && typeof cfg.data === 'object') {
            cfg.data = { companyDeptId, ...cfg.data };
        } else if (contentType.includes('application/json') && typeof cfg.data === 'string') {
            cfg.data = JSON.stringify({ companyDeptId, ...JSON.parse(cfg.data) });
        }else if (!Object.prototype.hasOwnProperty.call(cfg.params || {}, 'companyDeptId')) {
            cfg.params = {companyDeptId, ...cfg.params };
        }
    }
    return cfg;
};
/**
 * 判断请求是否是mock
 * @param url
 * @returns {boolean|*}
 */
export function isMock(url /* url, data, method, options */) {
    return mockUrls.indexOf(url) > -1 || url.startsWith('/mock');
}

/**
 * ajax工具，含有errorTip 和 successTip
 * @type {SXAjax}
 */
export const sxAjax = new SXAjax({
    onShowErrorTip: (error, errorTip) => handleError({ error, errorTip }),
    onShowSuccessTip: (response, successTip) => handleSuccess({ successTip }),
    isMock,
});

// 默认配置   发布到线上的时候需要改成这样sxAjax.defaults.baseURL = '/api/';本地开发sxAjax.defaults.baseURL = 'http://localhost:10007';

let winConfig = configEnv
sxAjax.defaults.baseURL = winConfig && winConfig.official
    ? window.location.href.split('//')[0] + '//' + winConfig.ajaxDefaults + '/api/'
    : '/api/';

//编辑器跳转路径
window.sessionStorage.setItem('to_h5edit_url', '/page/adpublish-edit/index.html');
let urlArr = window.location.href.split('/');
const h5edit_base_pre_url = urlArr[0] + '//' + urlArr[2] + sxAjax.defaults.baseURL;
window.localStorage.setItem('h5edit_base_pre_url', h5edit_base_pre_url);

// 默认配置
sxAjax.defaults.timeout = 1000 * 60;
sxAjax.mockDefaults.baseURL = '/';
sxAjax.crossDomain = true;
sxAjax.defaults.crossDomain = true;
// sxAjax.headers["access-token"] = localStorage.getItem("") || "";
;

/**
 * ajax高阶组件
 */
export const ajaxHoc = createAjaxHoc(sxAjax);

/**
 * ajax工具，不含有 errorTip和successTip
 * @type {SXAjax}
 */
export const ajax = new SXAjax({
    isMock,
});

// 默认配置
ajax.defaults.baseURL = '';
ajax.defaults.timeout = 1000 * 5;

// 请求前拦截
[ajax.instance, sxAjax.instance].forEach(instance => {
    instance.interceptors.request.use(cfg => {
        // Do something before request is sent
        if (cfg.headers) {
            cfg.headers['Accept-Language'] = window.localStorage.getItem('system-local')||"zh";
        }
        return injectCompanyDept(cfg);
    }, error => {
        console.log(error)
        // Do something with request error
        return Promise.reject(error);
    });
});


/**
 * mockjs使用的axios实例
 */
export const mockInstance = ajax.mockInstance = sxAjax.mockInstance;
